module.exports = __webpack_public_path__ + "img/s00162.252911cc.jpg";